
import styles from './GetStartedView.module.css';
import React from 'react';
import ServerEntry from '../components/ServerEntry';
import {
  Link
} from "react-router-dom";

class ActiveServerView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {servers: "pepega"};
  }

  fetchUserData() {
    console.log("fetchUserData was called");
    const requestOptions = {
      method: 'GET',
      headers: 
      {
        "authorization": localStorage.getItem("user_token")
      }
    };

    fetch(process.env.REACT_APP_INTERNAL_API_DOMAIN + 'user/me/guilds', requestOptions)
    .then(response => {
      if(response.status === 401 || response.status === 403)
      {
        console.log("Forcing the user to re-authorize:");
        window.location.href = `https://discord.com/oauth2/authorize?client_id=611247115829510165&redirect_uri=${process.env.REACT_APP_DISCORD_REDIRECTURI}&response_type=code&scope=identify%20guilds`; 
        return null;
      }
      console.log(response);
      return response;
    })
    .then(response => response.json())
    .then(data => {

      console.log("LOGGED IN AS:");
      this.setState({servers: data});
      console.log(data);

      this.forceUpdate();
      this.render();
    });
  }

  componentDidMount(){
    console.log("componentdidmount was called");
    console.log(this);
    this.fetchUserData();
  }

  render(){
    console.log(this.state.servers);
    console.log(typeof(this.state.servers.servers));
    if(this.state.servers === undefined || this.state.servers === "pepega") return null;

    const serverarray = [];

    this.state.servers.servers.forEach(server => {

      if((server.permissions & 0x00000020) === 0x00000020)
      {
      serverarray.push(<Link to={"/dashboard/server/" + server.id}>
        <ServerEntry avatar={"https://cdn.discordapp.com/icons/" + server.id + "/" + server.icon + ".png?size=128"} name={server.name}></ServerEntry>
      </Link>)
      }
    });

    return <div>
      <h1>Setup a new server</h1>
      <div class={styles.serverlist}>
        {serverarray}
      </div>
    </div>;
  }





}





export default ActiveServerView;
